import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router';
import MobileContext from 'Shared/contexts/MobileContext';

import ActionsAreaForMobile from './ActionsAreaForMobile/ActionsAreaForMobile';
import ActionsAreaForDesktop from './ActionsAreaForDesktop/ActionsAreaForDesktop';

type Props = {
  uuid: string;
  parentUuid: string;
  isActionItem: boolean;
  hideActionsAreaOnDesktop?: boolean;
  isSection: boolean;
  onAttachmentInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onArrowUpClick?: Function;
  onHideAnimationTrigger?: Function;
  // used in rare circumstance to force show mobile actions
  // in narrow instances: aka - the new comments details panel
  forceShowMobileActions?: boolean;
};

function ActionsArea({
  uuid,
  parentUuid,
  isActionItem,
  hideActionsAreaOnDesktop,
  isSection,
  onAttachmentInputChange,
  onArrowUpClick,
  onHideAnimationTrigger,
  forceShowMobileActions = false,
}: Props) {
  const location = useLocation();
  const history = useHistory();

  const handleOpenDetailsPanel = uuidParam => {
    const routeUuid = uuidParam || uuid;
    let path = location.pathname;
    // need to check and see if the panel is already open - if so, we need
    // strip the existing uuid off the route before appending the new one
    if (path.includes('/item/')) {
      path = path.split('/item/')[0];
    }

    // check for trailing slash
    path = path.slice(-1) === '/' ? path.slice(0, -1) : path;

    history.push({
      pathname: `${path}/item/${routeUuid}/comments`,
      state: { modal: location.state?.modal, preventPreviousRouteChange: location.state?.modal },
    });
  };

  const isMobile = useContext(MobileContext);

  return !isMobile && !hideActionsAreaOnDesktop && !forceShowMobileActions ? (
    <ActionsAreaForDesktop
      uuid={uuid}
      parentUuid={parentUuid}
      isActionItem={isActionItem}
      isSection={isSection}
      onHideAnimationTrigger={onHideAnimationTrigger}
      onAttachmentInputChange={onAttachmentInputChange}
      onArrowUpClick={onArrowUpClick}
      onCommentButtonClick={handleOpenDetailsPanel}
    />
  ) : (
    // (josh) -removing these display styles for now -
    // should be controlled by the if/else statement
    // <div className="d-block d-sm-none">
    <ActionsAreaForMobile uuid={uuid} onCommentButtonClick={handleOpenDetailsPanel} />
    // </div>
  );
}

export default React.memo(ActionsArea);
